export default {
	title: "My Profile",
	tabs: {
		personal: "Personal Info",
		religious: "Religious",
		security: "Security",
	},
	fields: {
		displayName: "Display name",
		email: "Email",
		phone: "Phone",
		whatsappOptIn: "Receive ORI alerts via WhatsApp",
		whatsappOptInHint: "Temple management notices (received payments, expenses, closing) sent from ORI's official number to the phone above",
		religiousName: "Religious name",
		title: "Title",
		ritualFunction: "Ritual function",
		role: "Temple role",
		currentPassword: "Current password",
		newPassword: "New password",
		confirmPassword: "Confirm new password",
	},
	photo: {
		change: "Change photo",
		remove: "Remove photo",
	},
	messages: {
		saved: "Profile updated successfully",
		photoUploaded: "Photo updated successfully",
		photoRemoved: "Photo removed successfully",
		errorSaving: "Error saving profile",
		errorPhoto: "Error updating photo",
		changePassword: "Change Password",
		passwordChanged: "Password changed successfully",
		passwordsDoNotMatch: "Passwords do not match",
		wrongCurrentPassword: "Current password is incorrect",
	},
	stats: {
		temple: "Temple",
	},
};
